import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-83">
      <div className="max-w-4xl mx-auto text-center" data-id="element-84">
        {/* Logo */}
        <div className="text-[#FFD700] text-3xl font-black tracking-widest mb-8" data-id="element-85">
          🎵 MEGAPACK MÚSICA LISTA
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-86">
          El próximo fin de semana puedes seguir buscando material en internet.
        </h2>
        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-6" data-id="element-87">
          O puedes tener todo resuelto desde hoy.
        </p>

        <p className="text-gray-400 text-sm sm:text-base italic mb-10 max-w-2xl mx-auto" data-id="element-88">
          Da igual si estás en España, en México, en Colombia, en Chile, en
          Perú, en Guatemala, en Cuba o en cualquier rincón del mundo donde se
          hable español. El problema es el mismo. La solución también.
        </p>

        {/* Countdown */}
        <div className="mb-4" data-id="element-89">
          <p className="text-white font-bold mb-4" data-id="element-90">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-91" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-92">
          Después sube el precio y no vuelve.
        </p>

        {/* 3 mini pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10" data-id="element-93">
          <div className="bg-[#0d0d00] border-2 border-[#FFD700] rounded-xl p-5 text-center shadow-[0_0_30px_rgba(255,215,0,0.2)]" data-id="element-94">
            <div className="text-2xl mb-2" data-id="element-95">🏆</div>
            <h3 className="text-[#FFD700] font-black mb-1" data-id="element-96">PACK COMPLETO ⭐</h3>
            <p className="text-gray-400 text-xs mb-2" data-id="element-97">
              12 tomos + 240 clases + 6 bonos
            </p>
            <p className="text-[#FFD700] text-3xl font-black mb-4" data-id="element-98">USD 19.90</p>
            <a href="https://docentes2.edulabs.online/cart/43111263240310:1" className="btn-gold-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-yellow-300 transition-colors text-sm" data-id="element-99">
              → QUIERO MI MEGAPACK COMPLETO
            </a>
          </div>
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-5 text-center" data-id="element-100">
            <div className="text-2xl mb-2" data-id="element-101">📘</div>
            <h3 className="text-white font-black mb-1" data-id="element-102">
              EDUCACIÓN PRIMARIA / BÁSICA
            </h3>
            <p className="text-gray-400 text-xs mb-2" data-id="element-103">
              6 tomos + 120 clases + 6 bonos
            </p>
            <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-104">USD 11.90</p>
            <a href="https://docentes2.edulabs.online/cart/43186090737782:1" className="btn-gold-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-yellow-300 transition-colors text-sm" data-id="element-105">
              → QUIERO PRIMARIA / BÁSICA
            </a>
          </div>
          <div className="bg-[#0a0a0a] border border-[#FFD700]/30 rounded-xl p-5 text-center" data-id="element-106">
            <div className="text-2xl mb-2" data-id="element-107">📗</div>
            <h3 className="text-white font-black mb-1" data-id="element-108">
              EDUCACIÓN SECUNDARIA / MEDIA
            </h3>
            <p className="text-gray-400 text-xs mb-2" data-id="element-109">
              6 tomos + 120 clases + 6 bonos
            </p>
            <p className="text-[#FFD700] text-2xl font-black mb-4" data-id="element-110">USD 13.90</p>
            <a href="https://docentes2.edulabs.online/cart/43186272534646:1" className="btn-gold-pulse block bg-[#FFD700] text-black font-black py-4 rounded-lg hover:bg-yellow-300 transition-colors text-sm" data-id="element-111">
              → QUIERO SECUNDARIA / MEDIA
            </a>
          </div>
        </div>

        <p className="text-gray-500 text-xs italic mb-8" data-id="element-112">
          El cobro se realiza en la moneda de tu país.
        </p>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-113">
          <span data-id="element-114">🔒 Pago 100% seguro</span>
          <span data-id="element-115">⚡ Acceso en 5 minutos</span>
          <span data-id="element-116">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-117">
            💳 Tarjeta de crédito | 🏦 Transferencia bancaria | 📱 Plataformas
            de pago locales
          </span>
        </div>
      </div>
    </section>;
}